/*
    These are actions for user selection objects.

    These are objects that just hold a list of users. They are used for
    creating review cycles, goals, etc.
*/
// dependencies
import { Map, fromJS } from "immutable";

import isArray from "../utils/IsArray";
// utils
import Print from "../utils/Print";

const baseAction = "SELECTIONS";

export function AddGroupToSelection(selectionId, groupIds, exclusionList, filters, callback) {
	return (dispatch) => {
		if (!isArray(groupIds)) {
			Print("warning", "This should be an array.");
			return;
		}

		const allUsers = groupIds.indexOf("all_users") >= 0;

		dispatch({
			type: `${baseAction}:ADD_GROUP`,
			selectionId,
			groups: groupIds,
			allUsers,
			exclusionList,
			filters,
			callback,
		});
	};
}

export function AddUserToSelection(selectionId, userIds, exclusionList, callback) {
	return (dispatch) => {
		if (!isArray(userIds)) {
			Print("warning", "This should be an array.");
			return;
		}

		dispatch({
			type: `${baseAction}:ADD_USER`,
			selectionId,
			users: userIds,
			exclusionList,
			callback,
		});
	};
}

export function RemoveUserFromSelection(selectionId, userIds, callback) {
	return (dispatch) => {
		if (!isArray(userIds)) {
			Print("warning", "This should be an array.");
			return;
		}

		dispatch({
			type: `${baseAction}:REMOVE_USER`,
			selectionId,
			users: userIds,
			callback,
		});
	};
}

export function UpdateUserSelectionMap(selectionObjectId = null, selectedUsers = {}) {
	return (dispatch) => {
		const selectedUsersMap = Map(selectedUsers);

		dispatch({
			type: `${baseAction}:UPDATE_SELECTION`,
			selectionObjectId,
			selectedUsersMap,
		});
	};
}

export function UpdateUserCount(selectionId = null) {
	return (dispatch) => {
		dispatch({ type: "SELECTIONS:COUNT", selectionId });
	};
}

export function ToggleUserSelection(selectionObjectId = null, userIds) {
	return (dispatch) => {
		/*
            This flips the boolean value of the current userId in the selection.
        */
		dispatch({
			type: `${baseAction}:TOGGLE_USER`,
			selectionObjectId,
			userIds,
		});
	};
}

/**
 * Will set the spinner of the current userId in the selection
 */
export function ToggleUserSelectionSpinner(selectionObjectId = null, userIds) {
	return (dispatch) => {
		dispatch({
			type: `${baseAction}:TOGGLE_SPINNER`,
			selectionObjectId,
			userIds,
		});
	};
}

export function ParseSelectionObject(selectionObjectId, data) {
	return (dispatch) => {
		/*
            Parse the selection object from the 'GET' request.

            The response data is an object with the keys 'all_users' and
            'groups'.
        */
		dispatch({
			type: `${baseAction}:PARSE_GET`,
			selectionObjectId,
			object: fromJS(data),
		});
	};
}
